// Clean, minimal organ line-vectors + very light pastel palette per organ.
export const ORGAN_COLORS = {
  kidney: { bg: "#EAF3F0", fg: "#5E9484", border: "#D5E6E1" },
  liver: { bg: "#F5EDE1", fg: "#B07A4A", border: "#E9DCC7" },
  heart: { bg: "#F9EAEB", fg: "#C06B6B", border: "#F0D7D8" },
  lung: { bg: "#E9EFF7", fg: "#6E8FB0", border: "#D8E3EF" },
  pancreas: { bg: "#F4F0E1", fg: "#A99453", border: "#E8E0C6" },
  intestine: { bg: "#F2EBF4", fg: "#8E7AA0", border: "#E3D8E9" },
  other: { bg: "#EFEFEC", fg: "#7A7A72", border: "#E3E3DD" },
};


// Minimalist matte organ renders (clay-style, one per organ).
export const ORGAN_IMAGES = {
  kidney: "https://static.prod-images.emergentagent.com/jobs/63227096-7576-4196-9731-b82d154cf8d0/images/52271cbeb27b0f9de6be0f6125e6a5b064bc2461708cb0b5f588894f3d387b5a.jpeg",
  liver: "https://static.prod-images.emergentagent.com/jobs/63227096-7576-4196-9731-b82d154cf8d0/images/ec4578382cafe712379f11d3bb9c17f7cbed5189779aa80edb0cade5ca699f9d.jpeg",
  heart: "https://static.prod-images.emergentagent.com/jobs/63227096-7576-4196-9731-b82d154cf8d0/images/6a4fa0d8c455d738fc74eabd608507ccafe7682499d78ffd6e03601cc0e54513.jpeg",
  lung: "https://static.prod-images.emergentagent.com/jobs/63227096-7576-4196-9731-b82d154cf8d0/images/46aafddaded6a3201d290bf9115614df689677c6b7d4a293b0b4bb98ea161a43.jpeg",
  pancreas: "https://static.prod-images.emergentagent.com/jobs/63227096-7576-4196-9731-b82d154cf8d0/images/6d01022fd0b15dfe6b9b3d4823777d403e2d8ad86e277469cb9ddb110efc67dd.jpeg",
  intestine: "https://static.prod-images.emergentagent.com/jobs/63227096-7576-4196-9731-b82d154cf8d0/images/d647dfe7e49f09cb8d41e0f81e39d536f01e9fb2da3c748befeb2386193a4fcb.jpeg",
};

export function OrganImage({ slug, className = "w-10 h-10", rounded = "rounded-xl" }) {
  const src = ORGAN_IMAGES[slug];
  if (!src) return null;
  return (
    <span className={`inline-flex overflow-hidden ${rounded} bg-white/80 shadow-sm ${className}`}>
      <img src={src} alt={`${slug} organ`} loading="lazy" className="w-full h-full object-cover" />
    </span>
  );
}

const PATHS = {
  kidney: (
    <>
      <path d="M8.5 4C6 4 4.5 6.5 4.5 10s1.5 6 4 6c1.4 0 2.3-.9 2.3-2.2 0-1.6-1.1-2.3-1.1-4.3s1.1-2.7 1.1-4.3C10.8 4.9 9.9 4 8.5 4Z" />
      <path d="M15.5 4c2.5 0 4 2.5 4 6s-1.5 6-4 6c-1.4 0-2.3-.9-2.3-2.2 0-1.6 1.1-2.3 1.1-4.3s-1.1-2.7-1.1-4.3c0-1.3.9-1.9 2.3-1.9Z" />
    </>
  ),
  liver: (
    <>
      <path d="M4.2 8.2C4.2 6.9 5.1 6 6.4 5.9c3.2-.5 6.8-.7 10-.5 1.9.1 3.1 1.3 3.3 3.2.4 4.2-3.6 9.2-9.2 9.2-3.6 0-6.4-1.9-7.7-5-.3-.9-.4-1.7-.4-2.6" />
      <path d="M11.8 5.7v3.6" />
    </>
  ),
  heart: (
    <path d="M12 20s-6.4-4.2-8.9-8C1.5 9.2 2.4 6 5.2 5.3 7 4.9 8.9 5.6 12 8.5c3.1-2.9 5-3.6 6.8-3.2 2.8.7 3.7 3.9 2.1 6.7C18.4 15.8 12 20 12 20z" />
  ),
  lung: (
    <>
      <path d="M10.8 4.5 12 3.4l1.2 1.1" />
      <path d="M12 3.4V9" />
      <path d="M12 9c-.8 1.7-3.2 2.3-4.4 3.9-1.6 1.8-1.4 5.1.2 6.3 1.4 1.1 3.1.2 3.5-1.5.3-1.4.4-3.1.4-4.6" />
      <path d="M12 9c.8 1.7 3.2 2.3 4.4 3.9 1.6 1.8 1.4 5.1-.2 6.3-1.4 1.1-3.1.2-3.5-1.5-.3-1.4-.4-3.1-.4-4.6" />
    </>
  ),
  pancreas: (
    <>
      <path d="M4.3 9.4C4.3 8 5.5 7 7.2 7.2c2.8.4 5 1.8 7.9 2.3 1.5.3 3 .4 3.6 1.6.5 1.1-.3 2.4-1.6 2.6-3.1.5-6.1-.7-9.2-.8-2-.1-3.6-1-3.6-3.5Z" />
      <path d="M18.7 12.6c1.1.2 1.8.9 1.8 1.8" />
      <circle cx="7.3" cy="9.9" r=".7" fill="currentColor" stroke="none" />
    </>
  ),
  intestine: (
    <>
      <path d="M6 5c0 1.6 1.5 2.1 3 2.1S12 6.6 12 5" />
      <path d="M5 9c0 1.8 2 2.5 3.8 2.5S12.5 10.8 12.5 9" />
      <path d="M6 13c0 1.6 1.7 2.2 3.2 2.2s3.1-.6 3.1-2.2" />
      <path d="M7 17c0 1.4 1.4 1.9 2.7 1.9" />
    </>
  ),
  other: (
    <>
      <circle cx="12" cy="12" r="8" />
      <circle cx="12" cy="12" r="2.6" fill="currentColor" stroke="none" />
    </>
  ),
};

export function OrganIcon({ slug, className = "w-8 h-8" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor"
      strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {PATHS[slug] || PATHS.other}
    </svg>
  );
}
